module.exports = __webpack_public_path__ + "src/assets/no.b81d6cff.png";